<ng-template #template>
  <div
    *ngFor="let group of data?.groups; last as isLast"
    style="line-height: 1.5"
  >
    <app-slider
      *ngFor="let slider of group.sliders"
      [sliderdata]="slider"
      [min]="min"
      (valuechanged)="changed(slider)"
    ></app-slider>
    <hr class="hr-white-20" *ngIf="!isLast" />
  </div>
</ng-template>
